export default "__VITE_ASSET__p12jii2h__"